module.exports = {
	"contractName": "VentureCapitalFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "85:411:27:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;85:411:27;;;;;;",
	"deployedSourceMap": "85:411:27:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;129:205;;-1:-1:-1;;;;;129:205:27;;;;;;;;;-1:-1:-1;;;;;129:205:27;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;338:156:27;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;338:156:27;-1:-1:-1;;;;;338:156:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;129:205:27;194:7;;243;230:9;:20;;222:29;;;;;;304:7;277:37;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;277:37:27;129:205;-1:-1:-1;;;;129:205:27:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;338:156:27:-;-1:-1:-1;;;;;;458:26:27;;:31;;338:156::o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;85:411:27:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./VentureCapital.sol\";\n\ncontract VentureCapitalFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    require(msg.value >= 1 ether);\n    VentureCapital vc = (new VentureCapital).value(1 ether)();\n    return vc;\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    return address(_instance).balance == 0;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapitalFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapitalFactory.sol",
		"exportedSymbols": {
			"VentureCapitalFactory": [
				2844
			]
		},
		"id": 2845,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2791,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:27"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2792,
				"nodeType": "ImportDirective",
				"scope": 2845,
				"sourceUnit": 2867,
				"src": "26:26:27",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapital.sol",
				"file": "./VentureCapital.sol",
				"id": 2793,
				"nodeType": "ImportDirective",
				"scope": 2845,
				"sourceUnit": 2790,
				"src": "53:30:27",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2794,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "119:5:27",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2795,
						"nodeType": "InheritanceSpecifier",
						"src": "119:5:27"
					}
				],
				"contractDependencies": [
					2789,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2844,
				"linearizedBaseContracts": [
					2844,
					2866,
					2922
				],
				"name": "VentureCapitalFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2823,
							"nodeType": "Block",
							"src": "203:131:27",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2802,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2797,
										"src": "209:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2803,
									"nodeType": "ExpressionStatement",
									"src": "209:7:27"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 2808,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2805,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "230:3:27",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2806,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "230:9:27",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2807,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "243:7:27",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "230:20:27",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2804,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "222:7:27",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2809,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "222:29:27",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2810,
									"nodeType": "ExpressionStatement",
									"src": "222:29:27"
								},
								{
									"assignments": [
										2812
									],
									"declarations": [
										{
											"constant": false,
											"id": 2812,
											"name": "vc",
											"nodeType": "VariableDeclaration",
											"scope": 2824,
											"src": "257:17:27",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_VentureCapital_$2789",
												"typeString": "contract VentureCapital"
											},
											"typeName": {
												"contractScope": null,
												"id": 2811,
												"name": "VentureCapital",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2789,
												"src": "257:14:27",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_VentureCapital_$2789",
													"typeString": "contract VentureCapital"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2820,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2817,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "304:7:27",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													}
												],
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"id": 2814,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "NewExpression",
															"src": "278:18:27",
															"typeDescriptions": {
																"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$",
																"typeString": "function () payable returns (contract VentureCapital)"
															},
															"typeName": {
																"contractScope": null,
																"id": 2813,
																"name": "VentureCapital",
																"nodeType": "UserDefinedTypeName",
																"referencedDeclaration": 2789,
																"src": "282:14:27",
																"typeDescriptions": {
																	"typeIdentifier": "t_contract$_VentureCapital_$2789",
																	"typeString": "contract VentureCapital"
																}
															}
														}
													],
													"id": 2815,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "277:20:27",
													"typeDescriptions": {
														"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$",
														"typeString": "function () payable returns (contract VentureCapital)"
													}
												},
												"id": 2816,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "277:26:27",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$value_$",
													"typeString": "function (uint256) returns (function () payable returns (contract VentureCapital))"
												}
											},
											"id": 2818,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "277:35:27",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$value",
												"typeString": "function () payable returns (contract VentureCapital)"
											}
										},
										"id": 2819,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "277:37:27",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_VentureCapital_$2789",
											"typeString": "contract VentureCapital"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "257:57:27"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2821,
										"name": "vc",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2812,
										"src": "327:2:27",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_VentureCapital_$2789",
											"typeString": "contract VentureCapital"
										}
									},
									"functionReturnParameters": 2801,
									"id": 2822,
									"nodeType": "Return",
									"src": "320:9:27"
								}
							]
						},
						"documentation": null,
						"id": 2824,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2798,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2797,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2824,
									"src": "153:15:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2796,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "153:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "152:17:27"
						},
						"payable": true,
						"returnParameters": {
							"id": 2801,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2800,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2824,
									"src": "194:7:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2799,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "194:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "193:9:27"
						},
						"scope": 2844,
						"src": "129:205:27",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2842,
							"nodeType": "Block",
							"src": "432:62:27",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2833,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2828,
										"src": "438:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2834,
									"nodeType": "ExpressionStatement",
									"src": "438:7:27"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2840,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 2836,
														"name": "_instance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2826,
														"src": "466:9:27",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													],
													"id": 2835,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "458:7:27",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 2837,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "458:18:27",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 2838,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "balance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "458:26:27",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2839,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "488:1:27",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "458:31:27",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2832,
									"id": 2841,
									"nodeType": "Return",
									"src": "451:38:27"
								}
							]
						},
						"documentation": null,
						"id": 2843,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2829,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2826,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2843,
									"src": "364:17:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2825,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "364:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2828,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2843,
									"src": "383:15:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2827,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "383:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "363:36:27"
						},
						"payable": false,
						"returnParameters": {
							"id": 2832,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2831,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2843,
									"src": "424:4:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2830,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "424:4:27",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "423:6:27"
						},
						"scope": 2844,
						"src": "338:156:27",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 2845,
				"src": "85:411:27"
			}
		],
		"src": "0:497:27"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapitalFactory.sol",
		"exportedSymbols": {
			"VentureCapitalFactory": [
				2844
			]
		},
		"id": 2845,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2791,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:27"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2792,
				"nodeType": "ImportDirective",
				"scope": 2845,
				"sourceUnit": 2867,
				"src": "26:26:27",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/VentureCapital.sol",
				"file": "./VentureCapital.sol",
				"id": 2793,
				"nodeType": "ImportDirective",
				"scope": 2845,
				"sourceUnit": 2790,
				"src": "53:30:27",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2794,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "119:5:27",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2795,
						"nodeType": "InheritanceSpecifier",
						"src": "119:5:27"
					}
				],
				"contractDependencies": [
					2789,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2844,
				"linearizedBaseContracts": [
					2844,
					2866,
					2922
				],
				"name": "VentureCapitalFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2823,
							"nodeType": "Block",
							"src": "203:131:27",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2802,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2797,
										"src": "209:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2803,
									"nodeType": "ExpressionStatement",
									"src": "209:7:27"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 2808,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2805,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "230:3:27",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2806,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "230:9:27",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2807,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "243:7:27",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "230:20:27",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2804,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "222:7:27",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2809,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "222:29:27",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2810,
									"nodeType": "ExpressionStatement",
									"src": "222:29:27"
								},
								{
									"assignments": [
										2812
									],
									"declarations": [
										{
											"constant": false,
											"id": 2812,
											"name": "vc",
											"nodeType": "VariableDeclaration",
											"scope": 2824,
											"src": "257:17:27",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_VentureCapital_$2789",
												"typeString": "contract VentureCapital"
											},
											"typeName": {
												"contractScope": null,
												"id": 2811,
												"name": "VentureCapital",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2789,
												"src": "257:14:27",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_VentureCapital_$2789",
													"typeString": "contract VentureCapital"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2820,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "31",
													"id": 2817,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "304:7:27",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													}
												],
												"expression": {
													"argumentTypes": null,
													"components": [
														{
															"argumentTypes": null,
															"id": 2814,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "NewExpression",
															"src": "278:18:27",
															"typeDescriptions": {
																"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$",
																"typeString": "function () payable returns (contract VentureCapital)"
															},
															"typeName": {
																"contractScope": null,
																"id": 2813,
																"name": "VentureCapital",
																"nodeType": "UserDefinedTypeName",
																"referencedDeclaration": 2789,
																"src": "282:14:27",
																"typeDescriptions": {
																	"typeIdentifier": "t_contract$_VentureCapital_$2789",
																	"typeString": "contract VentureCapital"
																}
															}
														}
													],
													"id": 2815,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "TupleExpression",
													"src": "277:20:27",
													"typeDescriptions": {
														"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$",
														"typeString": "function () payable returns (contract VentureCapital)"
													}
												},
												"id": 2816,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "value",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "277:26:27",
												"typeDescriptions": {
													"typeIdentifier": "t_function_setvalue_nonpayable$_t_uint256_$returns$_t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$value_$",
													"typeString": "function (uint256) returns (function () payable returns (contract VentureCapital))"
												}
											},
											"id": 2818,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "277:35:27",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_payable$__$returns$_t_contract$_VentureCapital_$2789_$value",
												"typeString": "function () payable returns (contract VentureCapital)"
											}
										},
										"id": 2819,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "277:37:27",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_VentureCapital_$2789",
											"typeString": "contract VentureCapital"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "257:57:27"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2821,
										"name": "vc",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2812,
										"src": "327:2:27",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_VentureCapital_$2789",
											"typeString": "contract VentureCapital"
										}
									},
									"functionReturnParameters": 2801,
									"id": 2822,
									"nodeType": "Return",
									"src": "320:9:27"
								}
							]
						},
						"documentation": null,
						"id": 2824,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2798,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2797,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2824,
									"src": "153:15:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2796,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "153:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "152:17:27"
						},
						"payable": true,
						"returnParameters": {
							"id": 2801,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2800,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2824,
									"src": "194:7:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2799,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "194:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "193:9:27"
						},
						"scope": 2844,
						"src": "129:205:27",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2842,
							"nodeType": "Block",
							"src": "432:62:27",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2833,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2828,
										"src": "438:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2834,
									"nodeType": "ExpressionStatement",
									"src": "438:7:27"
								},
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2840,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"id": 2836,
														"name": "_instance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2826,
														"src": "466:9:27",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													],
													"id": 2835,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "458:7:27",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 2837,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "458:18:27",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 2838,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "balance",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "458:26:27",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2839,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "488:1:27",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "458:31:27",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2832,
									"id": 2841,
									"nodeType": "Return",
									"src": "451:38:27"
								}
							]
						},
						"documentation": null,
						"id": 2843,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2829,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2826,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2843,
									"src": "364:17:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2825,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "364:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2828,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2843,
									"src": "383:15:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2827,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "383:7:27",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "363:36:27"
						},
						"payable": false,
						"returnParameters": {
							"id": 2832,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2831,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2843,
									"src": "424:4:27",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2830,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "424:4:27",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "423:6:27"
						},
						"scope": 2844,
						"src": "338:156:27",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 2845,
				"src": "85:411:27"
			}
		],
		"src": "0:497:27"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.816Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/VentureCapitalFactory.json
// module id = 1056
// module chunks = 0